import cx from 'classnames';

import { Button } from '../Button/Button';

import s from './CtaViewMore.module.css';
import s1 from 'themes/playful/components/PlayfulLayout.module.css';

type TProps = {
  onClick?: () => void;
  title?: string;
  to?: string;
};

export const CtaViewMore = ({ onClick, to, title = 'View more' }: TProps) => (
  <div className={s.wrapper}>
    <div className={s1.content}>
      <Button to={to} onClick={onClick} wrapArrow className={cx(s.viewMore)}>
        {title}
      </Button>
    </div>
  </div>
);
